import React from 'react';
import { BaseEdge, getSmoothStepPath } from 'reactflow';

/**
 * Animated Edge - Shows a moving circle along the edge path
 * Used during workflow execution to visualize data flow
 */
export function AnimatedEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    data = {}
}) {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const isAnimating = data?.isAnimating || false;
    const animationColor = data?.animationColor || '#1890ff';

    return (
        <>
            <BaseEdge 
                id={id} 
                path={edgePath} 
                style={{
                    ...style,
                    stroke: isAnimating ? animationColor : (style.stroke || '#b1b1b7'),
                    strokeWidth: isAnimating ? 3 : (style.strokeWidth || 2),
                }}
                markerEnd={markerEnd}
            />
            {isAnimating && (
                <>
                    {/* Glowing effect behind the moving circle */}
                    <circle r="12" fill={animationColor} opacity="0.3">
                        <animateMotion 
                            dur="1.5s" 
                            repeatCount="indefinite" 
                            path={edgePath} 
                        />
                    </circle>
                    {/* Main moving circle */}
                    <circle r="6" fill={animationColor}>
                        <animateMotion 
                            dur="1.5s" 
                            repeatCount="indefinite" 
                            path={edgePath} 
                        />
                    </circle>
                    {/* Inner white dot */}
                    <circle r="3" fill="#fff">
                        <animateMotion 
                            dur="1.5s" 
                            repeatCount="indefinite" 
                            path={edgePath} 
                        />
                    </circle>
                </>
            )}
        </>
    );
}

export default AnimatedEdge;
